import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
export var CurrentInsuranceCoverageMessage = function CurrentInsuranceCoverageMessage(_ref) {
  var eligibilityVerifiedAtDate = _ref.eligibilityVerifiedAtDate;
  var date = moment(eligibilityVerifiedAtDate);
  var formattedDate = date.format('MM/DD/YY[ at ]h[:]mm a');
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center my-2"
  }, /*#__PURE__*/React.createElement("p", null, "NCTracks results reflect client's current coverage status as of ", formattedDate, " and do not reflect past or future coverage. Only coverage for the current month is verified."));
};
CurrentInsuranceCoverageMessage.propTypes = {
  eligibilityVerifiedAtDate: PropTypes.string.isRequired
};
//# sourceMappingURL=CurrentInsuranceCoverageMessage.js.map